"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFn = void 0;
const createFn = (fnName, implementation) => {
    return (args, context) => {
        try {
            return implementation(args, context);
        }
        catch (e) {
            const err = new Error(`${fnName}: ${e instanceof Error ? e.message : e}`);
            err.cause = [args, context];
            throw err;
        }
    };
};
exports.createFn = createFn;
//# sourceMappingURL=create-fn.js.map